let maintenanceInProgress = false;
let maintenanceIsSoon = false;

export const setMaintenanceInProgress = inProgress => {
  maintenanceInProgress = inProgress;
};

export const setMaintenanceIsSoon = isSoon => {
  maintenanceIsSoon = isSoon;
};

export const isMaintenanceInProgress = () => maintenanceInProgress;

export const isMaintenanceSoon = () => maintenanceIsSoon;
